export enum Actions {
	Dev = 'https://www.dev.usccadev.com/ail/authenticate',
	Staging = 'https://www.usccadev.com/ail/authenticate',
	Prod = 'https://www.usconcealedcarry.com/ail/authenticate',
	Cabelas = 'https://www.cabelas-shield.com/ail/authenticate',
	StagingCabelas = 'https://staging.www.cabelas-shield.com/ail/authenticate'
}

enum EnvHostnameIndicators {
	LocalHost = 'localhost',
	Staging = 'deltadefensedev',
	Dev = 'dev.deltadefensedev',
	Cabelas = 'cabelas-shield',
	StagingCabelas = 'staging.cabelas-shield'
}

const envToActions: Record<EnvHostnameIndicators, Actions> = {
	[EnvHostnameIndicators.LocalHost]: Actions.Staging,
	[EnvHostnameIndicators.Dev]: Actions.Dev,
	[EnvHostnameIndicators.Staging]: Actions.Staging,
	[EnvHostnameIndicators.Cabelas]: Actions.Cabelas,
	[EnvHostnameIndicators.StagingCabelas]: Actions.StagingCabelas
};

export function setSSOFormAction(ssoForm: React.RefObject<HTMLFormElement | null>, windowRef = window) {
	if (ssoForm.current) {
		let finalAction = Actions.Prod;
		Object.values(EnvHostnameIndicators).forEach((partialHostname) => {
			if (windowRef.location.hostname.includes(partialHostname)) {
				finalAction = envToActions[partialHostname];
			}
		});
		ssoForm.current.action = finalAction;
	}
}
